export default {
  title: 'Add Service Account',
  menu: 'Add Service Account',
  label: {
    adminType: 'Admin Type',
    hQAdmin: 'HQ Admin',
    ajingaSystemAdmin: 'Ajinga System Admin',
    emailAddress: 'Email Address',
    companyId: 'Company Id',
    note: 'Note:',
    note1: 'HQ admin: Client company admin with all permissions.',
    note2: 'Ajinga system admin: Ajinga platform admin, with additional permissions to use "Approve company", "Setup premium function" and "Upload data" functions.'
  },
  placeholder: {
  },
  message: {
    createAdminSuccess: 'Create admin success'
  }
}
